import React, { memo } from "react";

const Home = memo(() => {
	return (
		<div className="jumbotron">
			<h1 className="display-4">Hello, CP Admin!</h1>
			<br />
			<p className="lead">
				Things to remember:
			</p>
			<p>
				Hovering over icons or buttons will display what they are used for.<br />
				For example:<br />
				&emsp;Eligible for connected services will display a &ldquo;chain&ldquo; icon<br /><br />

				If, on the vehicle, the row &ldquo;Claimed by&ldquo; is not <strong>customer</strong> then only
				the customer can be eligible for connected services.
			</p>
		</div>
	);
});
Home.displayName = `Home`;
export default Home;
